/*
 * PJ Video-Autoplay-Absicherung.
 *
 * Chrome pausiert autoplay-Videos im Energiesparmodus (Laptop im Akkubetrieb),
 * und das video-background-Component verliert autoplay durch sein manuelles
 * load(). Ein per Script ausgeloestes play() ist in beiden Faellen erlaubt.
 *
 * Bewusst NUR Hero- und Background-Videos: Reels/Slideshow/PDP-Medien haben
 * eigene Play/Pause-Logik (IntersectionObserver), der wir nicht in die Quere
 * kommen duerfen.
 */
(function () {
  var SELECTOR = 'video.hero__video, video-background-component video';

  function tryPlay(v) {
    if (v.paused && !v.ended && v.autoplay) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {}); // z.B. iOS Low Power: still scheitern, Standbild bleibt
    }
  }

  function kick() {
    document.querySelectorAll(SELECTOR).forEach(function (v) {
      tryPlay(v);

      // Chrome Energy-Saver pausiert auch NACH gelungenem Start wieder.
      // Diese Videos haben keine Controls — eine Pause kommt nie vom Nutzer,
      // also duerfen wir sanft neu anstossen. Gedeckelt, kein Dauerkampf.
      if (!v.dataset.pjKick) {
        v.dataset.pjKick = '0';
        v.addEventListener('pause', function () {
          var n = Number(v.dataset.pjKick);
          if (n >= 25 || v.ended || document.hidden) return;
          v.dataset.pjKick = String(n + 1);
          setTimeout(function () { tryPlay(v); }, 250);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kick);
  } else {
    kick();
  }
  window.addEventListener('load', kick);
  window.addEventListener('pageshow', kick); // Back-Forward-Cache
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) kick();
  });
  // video-background setzt seine Quellen erst nach Component-Upgrade
  setTimeout(kick, 1500);
  setTimeout(kick, 4000);
})();
